import React from "react";

/**
 * R6 B5 — Stale Leads Heatmap (reps × time buckets).
 */
const BUCKET_DAYS = { b14: 14, b30: 30, b60: 60, b60p: 90 };

function intensity(n, max) {
  if (!max || !n) return 0;
  return Math.min(1, n / max);
}

export default function StaleLeadsHeatmap({ buckets = [], rows = [], onDrill }) {
  const keys = ["b14", "b30", "b60", "b60p"];
  const max = rows.reduce((m, r) => Math.max(m, ...keys.map((k) => r[k] || 0)), 0) || 1;

  return (
    <div className="r6-analytics-block">
      <h3 className="r6-analytics-title">Stale Leads Heatmap</h3>
      <div className="r6-analytics-table-wrap">
        <table className="r6-analytics-table r6-heatmap">
          <thead>
            <tr>
              <th>Rep</th>
              {keys.map((k) => {
                const b = buckets.find((x) => x.key === k);
                return <th key={k}>{b?.label || k}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={5} className="r6-analytics-empty">No data</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.rep_id}>
                <td>{r.rep_name}</td>
                {keys.map((k) => (
                  <td
                    key={k}
                    className="r6-heatmap-cell r6-analytics-clickable"
                    style={{ background: `rgba(72,160,220,${intensity(r[k] || 0, max) * 0.6})` }}
                    onClick={() =>
                      onDrill?.({
                        salesRep: r.rep_id,
                        stale: "1",
                        staleDays: BUCKET_DAYS[k],
                      })
                    }
                  >
                    {r[k] || 0}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}